export default __webpack_public_path__ + "static/favicon-47be75af6494eef89c39124486496428.ico";